import { Component, Input } from '@angular/core'
import { CardTypeEnum } from '@shared/enums'
import { CardHelper } from '@shared/utils'
import { SvgIconComponent } from 'angular-svg-icon'

@Component({
  selector: 'app-small-vertical-card',
  standalone: true,
  imports: [SvgIconComponent],
  templateUrl: './small-vertical-card.component.html',
  styleUrl: './small-vertical-card.component.sass',
})
export class SmallVerticalCardComponent {
  @Input() number: number
  @Input() type: CardTypeEnum

  get label(): string {
    return CardHelper.getInitial(this.number || 0)
  }

  get isRedCard(): boolean {
    return [CardTypeEnum.HEART, CardTypeEnum.DIAMOND].includes(this.type)
  }

  get svgUrl(): string {
    return `assets/cards/symbols/${this.type}-symbol.svg`
  }
}
